<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="50%"
      :show-header="false"
      :close-on-click-modal="false"
      :show-close="false"
      append-to-body
      class="append"
      @open="getUserPlaylist"
    >
      <div style="padding-left: 50px; line-height: 1rem">
        <el-button
          type="text"
          @click="handleAppPlaylist"
          icon="el-icon-plus"
          style="color: #ff6491"
          >新建歌单</el-button
        >
      </div>
      <div class="myLike" @click="appendMyLike" title="添加到我的喜欢">
        <span style="display: inline-block; width: 120px; text-align: center"
          ><el-button
            type="danger"
            icon="iconfont icon-xihuan"
            circle
          ></el-button
        ></span>
        <span style="padding-left: 10px">我的喜欢</span>
      </div>
      <el-table
        :data="userPlaylist"
        v-loading="loading"
        style="width: 100%"
        v-if="userPlaylistLength > 0"
        stripe
        height="300"
      >
        <el-table-column prop="list_img" max-width="120" align="center">
          <template slot-scope="{ row }">
            <el-image
              style="width: 45px; height: 45px; border-radius: 5px"
              :src="row.list_img"
              fit="cover"
              v-if="row.list_img"
            ></el-image>
            <img
              style="width: 45px; height: 45px; border-radius: 5px"
              src="@/assets/images/default-playlist.png"
              v-else
            />
          </template>
        </el-table-column>
        <el-table-column prop="list_title" max-width="240" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.list_title }}
            <div>{{ row.song_num }}首歌</div>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot-scope="{ row }">
            <el-button
              v-no-more-click
              type="text"
              @click="appendSong(row)"
              icon="el-icon-folder-checked"
              class="appendBtn"
              title="添加到当前歌单"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新建歌单 -->
    <el-dialog
      title="建立歌单"
      :visible.sync="openNerPlaylist"
      width="50%"
      @close="dialogClosed"
      class="add_playlist"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="16">
          <el-form ref="form" :rules="rules" :model="form" label-width="80px">
            <el-form-item label="歌单标题" prop="list_title">
              <el-input
                v-model="form.list_title"
                placeholder="请输入歌单标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="歌单类型" prop="list_type">
              <el-drag-select
                v-model="form.list_type"
                style="width: 100%"
                multiple
                placeholder="请选择歌单类型"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.ca_id"
                  :label="item.ca_name"
                  :value="item.ca_id"
                />
              </el-drag-select>
            </el-form-item>
            <el-form-item label="介绍">
              <el-input
                type="textarea"
                :rows="5"
                v-model="form.list_details"
                placeholder="简单介绍下歌单"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-upload
            class="avatar-uploader"
            action="/upload/list"
            :headers="$uploadAuthHeaders()"
            :show-file-list="false"
            :on-success="upload"
          >
            <img v-if="form.list_img" :src="form.list_img" class="avatar" />
            <img
              v-else
              src="@/assets/images/default-playlist.png"
              class="avatar"
            />
            <div class="cover">编辑封面</div>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openNerPlaylist = false">取 消</el-button>
        <el-button v-no-more-click type="danger" @click="newPlaylist"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElDragSelect from "@/components/DragSelect";
export default {
  components: { ElDragSelect },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    songId: {
      type: [Boolean, Number],
      default: null,
    },
    // 弹出层标题
    title: {
      type: String,
      default: "加入歌单",
    },
  },
  data() {
    return {
      loading: false,
      u_id: null,
      userPlaylist: [],
      userPlaylistLength: 0,
      form: {
        list_title: "",
        list_type: [],
        list_details: [],
      },
      openNerPlaylist: false,
      categoryOptions: [],
      rules: {
        list_title: [
          { required: true, message: "歌单标题不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.u_id = window.sessionStorage.getItem("userID");
    this.$http.get("/query/comQuery/category").then((response) => {
      this.categoryOptions = response.data.data;
    });
  },
  methods: {
    async getUserPlaylist() {
      // console.log(this.$store.state.user.u_id);
      this.loading = true;
      const { data: res } = await this.$http.get("/query/comQuery/" + "lists", {
        params: { id: this.u_id },
      });
      this.userPlaylist = res.data;
      this.userPlaylistLength = this.userPlaylist.length;
      this.loading = false;
    },
    async appendMyLike() {
      const { data: res } = await this.$http.post("/music/like", {
        m_id: this.songId,
        u_id: this.u_id,
      });
      if (res.code !== 200) {
        return this.$message.warning(res.message);
      }
      this.$message.success("添加成功");
      this.open = false;
      this.close();
    },
    async appendSong(row) {
      // console.log(row.list_id, this.songId);
      const { data: res } = await this.$http.post("/playlist/tracks", {
        op: "add",
        list_id: row.list_id,
        m_id: this.songId,
      });
      if (res.code !== 200) {
        return this.$message.warning(res.message);
      }
      this.$message.success("添加成功");
      this.open = false;
      this.close();
    },
    close() {
      this.$emit("onCancel");
    },
    handleAppPlaylist() {
      this.openNerPlaylist = true;
    },
    // 新建歌单
    newPlaylist() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.list_author = window.sessionStorage.getItem("userID");
          const { data: res } = await this.$http.post("playlist", this.form);
          if (res.code !== 200) {
            return this.$message.error("新建歌单失败!");
          }
          this.openNerPlaylist = false;
          this.getUserPlaylist();
          this.$message.success("新建歌单成功");
        }
      });
    },
    upload(res) {
      this.$set(this.form, "list_img", res.url);
      // console.log(this.form.list_img);
    },
    dialogClosed() {
      this.form.list_title = "";
      this.form.list_details = "";
      this.form.list_img = "";
      this.$refs.form.resetFields();
      this.openNerPlaylist = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__header {
  display: none;
}
::v-deep .el-dialog {
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__header {
    background-color: #5d5d5d;
  }
}
.appendBtn {
  margin-right: 2em;
  font-size: 1.5em;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    color: #ff6491;
  }
}
.append {
  .myLike {
    line-height: 4em;
    cursor: pointer;
    &:hover {
      background-color: #f5f7fa;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  ::v-deep .el-table {
    margin-top: 0;
    .el-table__cell {
      padding: 10px 0;
    }
  }
}
</style>
